import { render, staticRenderFns } from "./ConfirmationModal.vue?vue&type=template&id=0a31fe62&"
import script from "./ConfirmationModal.ts?vue&type=script&lang=js&"
export * from "./ConfirmationModal.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports